import { KeyValue } from '@/main/models/common';
import { UserGroupFilterRequest } from '@/main/models/request/usergroupRequest';

export enum UserGroupTypes {
  GET_USERSGROUP_USER = '@userGroup/GET_USERSGROUP_USER',
  SAVE_USERSGROUP_USER = '@userGroup/SAVE_USERSGROUP_USER',
  RESET_REDUCER_USERSGROUP_USER = '@cuserGroup/RESET_REDUCER_USERSGROUP_USER'
}

export interface UserGroupState {
  readonly usersGroup: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetUsersGroupUser {
  type: typeof UserGroupTypes.GET_USERSGROUP_USER;
  payload: { groupFilter: UserGroupFilterRequest };
}

export interface SaveUsersGroupUser {
  type: typeof UserGroupTypes.SAVE_USERSGROUP_USER;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerUsersGroupUser {
  type: typeof UserGroupTypes.RESET_REDUCER_USERSGROUP_USER;
}

export type UserGroupActionTypes =
  | GetUsersGroupUser
  | SaveUsersGroupUser
  | ResetReducerUsersGroupUser;
